import axiosInstance from 'api/axiosInstance'

export const getLanguages = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/languages'
    })

    return data?.data
}

export const setLanguage = async (id: number) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/set-language',
        data: {
            language_id: id
        }
    })
    return data
}
